/**
 * FilePill — React twin of the markdown-side `.papan-file-chip`
 * (MarkdownContent builds those as raw HTML inside sanitized markdown;
 * tool rows are React and use this component). Same class, same look:
 * one visual language for "a workspace file" everywhere in chat.
 */
import { chipIconInner, chipDisplayName } from './chipIcon.js'

interface Props {
  /** Full /papan/... path (used for the click + hover title) */
  path: string
  /** Display label; defaults to the basename */
  label?: string
  onClick?: (path: string) => void
}

export function FilePill({ path, label, onClick }: Props) {
  const display = label || chipDisplayName(path)
  return (
    <button
      type="button"
      className="papan-file-chip"
      title={path}
      onClick={onClick ? (e) => { e.stopPropagation(); onClick(path) } : undefined}
    >
      {/* Per-type icon, shared with the markdown-side chip via chipIcon.ts */}
      <svg
        viewBox="0 0 24 24"
        width={12}
        height={12}
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden
        dangerouslySetInnerHTML={{ __html: chipIconInner(path) }}
      />
      <span>{display}</span>
    </button>
  )
}
